import { cn } from '@/utils/helpers';

export type PinIconProps = {
  /** Solid purple pin when pinned; outline when unpinned. */
  filled?: boolean;
  className?: string;
};

const PIN_HEAD_FILLED =
  'M2.24755 2.57852C2.00253 1.96595 1.88001 1.65966 1.9311 1.41379C1.97578 1.19878 2.10353 1.01009 2.28657 0.888753C2.49588 0.75 2.82576 0.75 3.48552 0.75H9.54677C10.2065 0.75 10.5364 0.75 10.7457 0.888753C10.9288 1.01009 11.0565 1.19878 11.1012 1.41379C11.1523 1.65966 11.0298 1.96595 10.7847 2.57852L9.94484 4.67826C9.90921 4.76733 9.8914 4.81187 9.87887 4.8578C9.86773 4.89861 9.85972 4.94021 9.8549 4.98223C9.84948 5.02954 9.84948 5.07751 9.84948 5.17344V6.94896C9.84948 7.12231 9.84948 7.20898 9.86649 7.29188C9.88159 7.36544 9.90656 7.43661 9.94072 7.50348C9.97922 7.57884 10.0334 7.64652 10.1417 7.78188L11.4498 9.41707C12.0046 10.1105 12.282 10.4573 12.2823 10.7491C12.2826 11.0029 12.1672 11.243 11.9688 11.4013C11.7408 11.5833 11.2967 11.5833 10.4086 11.5833H2.62365C1.73556 11.5833 1.29152 11.5833 1.06346 11.4013C0.865114 11.243 0.749726 11.0029 0.75 10.7491C0.750316 10.4573 1.02771 10.1105 1.58249 9.41707L2.89064 7.78189C2.99893 7.64652 3.05307 7.57884 3.09158 7.50348C3.12574 7.43661 3.1507 7.36544 3.1658 7.29188C3.18281 7.20898 3.18281 7.12231 3.18281 6.94896V5.17344C3.18281 5.07751 3.18281 5.02954 3.17739 4.98223C3.17257 4.94021 3.16456 4.89861 3.15343 4.8578C3.14089 4.81187 3.12308 4.76733 3.08745 4.67826L2.24755 2.57852Z';

const PIN_HEAD_OUTLINE =
  'M6.66707 6.0901V7.86561C6.66707 8.03896 6.66707 8.12564 6.65005 8.20854C6.63496 8.28209 6.60999 8.35327 6.57583 8.42013C6.53733 8.4955 6.48318 8.56318 6.37489 8.69854L5.06674 10.3337C4.51196 11.0272 4.23457 11.3739 4.23425 11.6658C4.23398 11.9195 4.34937 12.1596 4.54771 12.3179C4.77577 12.5 5.21982 12.5 6.1079 12.5H13.8929C14.781 12.5 15.225 12.5 15.4531 12.3179C15.6514 12.1596 15.7668 11.9195 15.7665 11.6658C15.7662 11.3739 15.4888 11.0272 14.9341 10.3337L13.6259 8.69854C13.5176 8.56318 13.4635 8.4955 13.425 8.42013C13.3908 8.35327 13.3658 8.28209 13.3507 8.20854C13.3337 8.12564 13.3337 8.03896 13.3337 7.86561V6.0901C13.3337 5.99416 13.3337 5.94619 13.3392 5.89889C13.344 5.85686 13.352 5.81527 13.3631 5.77446C13.3757 5.72853 13.3935 5.68399 13.4291 5.59491L14.269 3.49518C14.514 2.8826 14.6365 2.57632 14.5854 2.33044C14.5408 2.11543 14.413 1.92675 14.23 1.80541C14.0207 1.66666 13.6908 1.66666 13.031 1.66666H6.96978C6.31001 1.66666 5.98013 1.66666 5.77082 1.80541C5.58778 1.92675 5.46004 2.11543 5.41536 2.33044C5.36426 2.57632 5.48678 2.8826 5.73181 3.49518L6.5717 5.59491C6.60733 5.68399 6.62515 5.72853 6.63768 5.77446C6.64881 5.81527 6.65682 5.85686 6.66164 5.89889C6.66707 5.94619 6.66707 5.99416 6.66707 6.0901Z';

/** Outline vs filled only — size from `.pin-icon` in CSS. */
export function PinIcon({ filled = false, className }: PinIconProps) {
  if (filled) {
    return (
      <svg
        viewBox="0 0 14 19"
        fill="none"
        preserveAspectRatio="xMidYMid meet"
        className={cn('pin-icon', 'pin-icon--filled', className)}
        aria-hidden
      >
        <path d={PIN_HEAD_FILLED} fill="currentColor" />
        <path
          d="M6.51615 11.5833V17.4167"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      </svg>
    );
  }

  return (
    <svg
      viewBox="0 0 20 20"
      fill="none"
      preserveAspectRatio="xMidYMid meet"
      className={cn('pin-icon', className)}
      aria-hidden
    >
      <path
        d={PIN_HEAD_OUTLINE}
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.0004 12.5V18.3333"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
}
